import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { signeesService } from "@modules/organizationalStructure/signees/services/signees";
import useFormHook from "@shared/hooks/useFormHook";
import { notifySuccess } from "@config/tostifyConfig/tostifyConfig";

export default function SigneesTranslations({ onClose, signee, onSuccess }) {
    const { t } = useTranslation();
    const { modalRef } = useFormHook({}, onClose);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { register, handleSubmit, setValue } = useForm();

    useEffect(() => {
        const fetchTranslations = async () => {
            if (signee) {
                try {
                    setLoading(true);
                    setError(null);
                    const translationData = await signeesService.getTranslation(signee.id);
                    
                    // Set original values
                    setValue('jobDescription', signee.jobDescription || '');
                    
                    // Set translated values if they exist
                    if (translationData && translationData.length > 0) {
                        const translation = translationData[0]; // Get first translation
                        setValue('jobDescriptionTranslated', translation.jobDescription || '');
                    } else {
                        // If no translations exist, set empty values
                        setValue('jobDescriptionTranslated', '');
                    }
                } catch (err) {
                    console.error('Error fetching translations:', err);
                    setError('Failed to load translations');
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchTranslations();
    }, [signee, setValue]);

    const submitForm = async (data) => {
        try {
            const translationData = {
                hrLabourDocSignId: signee.id,
                langCode: "en_GB",
                jobDescription: data.jobDescriptionTranslated,
                isTranslated: "Y"
            };

            await signeesService.saveTranslation(translationData);
            onClose();
            notifySuccess(t('common.translationSuccessfully'));
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            console.error('Error saving translation:', error);
            setError('Failed to save translation');
        }
    }
    
    if (loading) {
        return (
            <div className="modal show" tabIndex="-1">
                <div className="modal-dialog modal-confirm" ref={modalRef}>
                    <div className="modal-content">
                        <div className="modal-body">
                            <p>Loading translations...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {t('organizationalStructure.signees.form.translations')}
                        </h4>
                        <form id="translationsForm" className="region-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="form-sections">
                                <div className="form-section width-80">
                                    <div className="form-group">
                                        <span className="span-bold">{t('organizationalStructure.signees.form.position')}</span>
                                        <input
                                            type="text"
                                            className="small-input"
                                            {...register('jobDescription', { required: true })}
                                            disabled
                                        />
                                    </div>
                                </div>

                                <div className="form-section width-80">
                                    <div className="form-group">
                                        <span className="span-bold">{t('organizationalStructure.signees.form.positionTranslated')}</span>
                                        <input
                                            type="text"
                                            className="small-input"
                                            {...register('jobDescriptionTranslated', { required: true })}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" form="translationsForm" className="btn btn-primary">
                            {t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}